const orders = [
  {
    name: 'Marty Otte',
    address: 'Kansas City, USA',
    date: '02.01.2019',
    statusColor: 'secondary',
    status: 'ON HOLD'
  },
  {
    name: 'Linn Ronning',
    address: 'Toronto, Canada',
    date: '02.04.2018',
    statusColor: 'primary',
    status: 'PROCESSED'
  },
  {
    name: 'Rasheeda Vaquera',
    address: 'Kühndorf, Germany',
    date: '02.02.2019',
    statusColor: 'primary',
    status: 'PROCESSED'
  },
  {
    name: 'Esperanza Lodge',
    address: 'Montluçon, France',
    date: '20.03.2018',
    statusColor: 'primary',
    status: 'PROCESSED'
  },
  {
    name: 'Ken Ballweg',
    address: 'Birmingham, UK',
    date: '17.02.2018',
    statusColor: 'secondary',
    status: 'ON HOLD'
  }

]
export default orders
